{
  "01-quellen": {
    "bild": "/hilfe/01-quellen.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 0,
        "oben": 20.19,
        "breite": 16.53,
        "hoehe": 3.13,
        "ruf": "Datenquellen"
      },
      {
        "links": 17.92,
        "oben": 16.63,
        "breite": 8.34,
        "hoehe": 4.92,
        "ruf": "hier drücken"
      }
    ]
  },
  "02-quellenblatt": {
    "bild": "/hilfe/02-quellenblatt.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 40.28,
        "oben": 25.59,
        "breite": 28.09,
        "hoehe": 26.51,
        "ruf": "ausfüllen"
      },
      {
        "links": 40.42,
        "oben": 52.76,
        "breite": 6.48,
        "hoehe": 4.92,
        "ruf": "Anlegen"
      }
    ]
  },
  "03-mapping": {
    "bild": "/hilfe/03-mapping.png",
    "datum": "2026-10-16",
    "markierungen": [
      {
        "links": 18.68,
        "oben": 6.09,
        "breite": 16.53,
        "hoehe": 6.77,
        "ruf": "suchen"
      },
      {
        "links": 35.63,
        "oben": 6.06,
        "breite": 14.44,
        "hoehe": 6.8,
        "ruf": "Gesellschaft wählen"
      }
    ]
  },
  "04-lieferung": {
    "bild": "/hilfe/04-lieferung.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 0,
        "oben": 23.32,
        "breite": 16.53,
        "hoehe": 3.13,
        "ruf": "Importieren"
      },
      {
        "links": 17.78,
        "oben": 20.98,
        "breite": 28.09,
        "hoehe": 26.83,
        "ruf": "Quelle, Periode, Datei"
      },
      {
        "links": 17.92,
        "oben": 48.47,
        "breite": 5.71,
        "hoehe": 4.92,
        "ruf": "Prüfen"
      }
    ]
  },
  "05-vorschau": {
    "bild": "/hilfe/05-vorschau.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 17.78,
        "oben": 14.54,
        "breite": 80.97,
        "hoehe": 8.64,
        "ruf": "gelesen, gültig, Probe"
      },
      {
        "links": 17.85,
        "oben": 47.58,
        "breite": 80.83,
        "hoehe": 52.42,
        "ruf": "Zeile für Zeile"
      }
    ]
  },
  "06-uebernehmen": {
    "bild": "/hilfe/06-uebernehmen.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 17.92,
        "oben": 68.44,
        "breite": 12.42,
        "hoehe": 4.92,
        "ruf": "Übernehmen"
      }
    ]
  },
  "07-bilanz": {
    "bild": "/hilfe/07-bilanz.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 16.53,
        "oben": 0,
        "breite": 83.47,
        "hoehe": 9.78,
        "ruf": "Zeitraum setzen"
      },
      {
        "links": 0,
        "oben": 30.13,
        "breite": 16.53,
        "hoehe": 4.26,
        "ruf": "Berichte"
      }
    ]
  },
  "k1-kontenrahmen": {
    "bild": "/hilfe/k1-kontenrahmen.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 0,
        "oben": 57.63,
        "breite": 16.53,
        "hoehe": 3.13,
        "ruf": "Stammdaten → Kontenrahmen"
      },
      {
        "links": 17.92,
        "oben": 19.88,
        "breite": 8.34,
        "hoehe": 4.92,
        "ruf": "hier drücken"
      }
    ]
  },
  "k2-anlegen": {
    "bild": "/hilfe/k2-anlegen.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 40.28,
        "oben": 17.51,
        "breite": 28.09,
        "hoehe": 26.51,
        "ruf": "ausfüllen"
      },
      {
        "links": 40.42,
        "oben": 44.68,
        "breite": 6.48,
        "hoehe": 4.92,
        "ruf": "Anlegen"
      }
    ]
  },
  "k3-gruppe": {
    "bild": "/hilfe/k3-gruppe.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 40.49,
        "oben": 69.44,
        "breite": 38.99,
        "hoehe": 5.56,
        "ruf": "hier erbt das Konto"
      }
    ]
  },
  "k4-zuordnung": {
    "bild": "/hilfe/k4-zuordnung.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 40.28,
        "oben": 63.62,
        "breite": 28.09,
        "hoehe": 28.52,
        "ruf": "Konto, Position, ab wann"
      },
      {
        "links": 40.42,
        "oben": 92.8,
        "breite": 6.48,
        "hoehe": 4.92,
        "ruf": "Anlegen"
      }
    ]
  },
  "k5-baum": {
    "bild": "/hilfe/k5-baum.png",
    "datum": "2026-10-16",
    "markierungen": [
      {
        "links": 24.24,
        "oben": 30.21,
        "breite": 57.25,
        "hoehe": 3.13,
        "ruf": "hier hängt es"
      }
    ]
  },
  "k6-umbenennen": {
    "bild": "/hilfe/k6-umbenennen.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 40.35,
        "oben": 31.38,
        "breite": 39.31,
        "hoehe": 13.5,
        "ruf": "neue Bezeichnung eintragen"
      }
    ]
  },
  "g1-einheit": {
    "bild": "/hilfe/g1-einheit.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 0,
        "oben": 54.5,
        "breite": 16.53,
        "hoehe": 3.13,
        "ruf": "Stammdaten → Gesellschaften"
      },
      {
        "links": 40.28,
        "oben": 17.51,
        "breite": 28.09,
        "hoehe": 33.95,
        "ruf": "Code, Bezeichnung, Land, Währung"
      },
      {
        "links": 40.42,
        "oben": 52.12,
        "breite": 6.48,
        "hoehe": 4.92,
        "ruf": "Anlegen"
      }
    ]
  },
  "g2-beteiligung": {
    "bild": "/hilfe/g2-beteiligung.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 17.92,
        "oben": 5.06,
        "breite": 20.21,
        "hoehe": 19.74,
        "ruf": "Objektart"
      },
      {
        "links": 40.28,
        "oben": 17.51,
        "breite": 28.09,
        "hoehe": 43.64,
        "ruf": "Tochter, Halter, Quote, ab wann"
      },
      {
        "links": 40.42,
        "oben": 61.81,
        "breite": 6.48,
        "hoehe": 4.92,
        "ruf": "Anlegen"
      }
    ]
  },
  "g3-kreis": {
    "bild": "/hilfe/g3-kreis.png",
    "datum": "2026-09-18",
    "markierungen": [
      {
        "links": 17.92,
        "oben": 5.06,
        "breite": 20.21,
        "hoehe": 19.74,
        "ruf": "Objektart"
      },
      {
        "links": 40.28,
        "oben": 17.51,
        "breite": 28.09,
        "hoehe": 26.51,
        "ruf": "Kreis, Gesellschaft, ab wann"
      },
      {
        "links": 40.42,
        "oben": 44.68,
        "breite": 6.48,
        "hoehe": 4.92,
        "ruf": "Anlegen"
      }
    ]
  }
}
